'use strict';

/**
 * Start timer to resend OTP code
 * @param {number} durationSeconds - Duration of the timer in seconds
 */
function startResendTimer(durationSeconds) {
    var $resendBtn = $('#btn-resend-otp');
    var $timerDisplay = $('#otp-timer');
    var timeLeft = durationSeconds;

    $resendBtn.addClass('disabled').prop('disabled', true);

    var interval = setInterval(function () {
        var minutes = Math.floor(timeLeft / 60);
        var seconds = timeLeft % 60;
        seconds = seconds < 10 ? '0' + seconds : seconds;
        minutes = minutes < 10 ? '0' + minutes : minutes;
        if (timeLeft <= 0) {
            clearInterval(interval);
            $resendBtn.removeClass('disabled').prop('disabled', false);
            $timerDisplay.text('');
        } else {
            if(timeLeft >= 60){
                $timerDisplay.text('Podrás reenviar en ' + minutes + ':' + seconds + ' minutos');
            }else{
                $timerDisplay.text('Podrás reenviar en ' + timeLeft + ' segundos');
            }
            timeLeft--;
        }
    }, 1000);
}

/**
 * Displays alerts within the modal
 * @param {string} type - Type of alert (error, success, clear)
 * @param {string} message - Message to display
 */
function showAlert(type, message) {
    var $errorAlert = $('#otp-error-alert');
    var $successAlert = $('#otp-success-alert');

    $errorAlert.addClass('d-none').text('');
    $successAlert.addClass('d-none').text('');

    if (type === 'error') {
        $errorAlert.removeClass('d-none').text(message);
    } else if (type === 'success') {
        $successAlert.removeClass('d-none').text(message);
    }
}

module.exports = {
    /**
     * Opens the OTP modal configuring the client's email
     * @param {string} email - Email to verify
     * @param {string} url - URL to request OTP
     * @param {string} otpFlow - Flow of OTP verification
     */
    openModal: function (email, url, otpFlow) {
        $.ajax({
            url: url,
            method: "POST",
            data: {
                email: email
            },
            success: function (data) {
                if (data.success) {
                    $('#otp-email-hidden').val(email);
                    $('#otp-verified-flow').val(otpFlow);
                    $('#otp-target-email-display').text(email);
                    $('#otpCodeInput').val('');
                    showAlert('clear');
                    
                    $('#otp-verification-modal').modal('show');
                    startResendTimer(data.resendTime);
                }
            }
        });
    },

    /**
     * Initializes the OTP modal form events
     */
    init: function () {

        $(document).on("input", "#otpCodeInput", function (e) {
            e.preventDefault();
            this.value = this.value.replace(/[^0-9]/g,'');
        });

        // Submit OTP verification form
        $('#otp-verification-form').off('submit').on('submit', function (e) {
            e.preventDefault();

            var $form = $(this);
            var url = $form.attr('action');
            var formData = $form.serialize();
            var $submitBtn = $('#btn-verify-otp');

            $submitBtn.prop('disabled', true);
            showAlert('clear');

            $.ajax({
                url: url,
                type: 'POST',
                data: formData,
                success: function (data) {
                    $submitBtn.prop('disabled', false);

                    if (data.success) {
                        setTimeout(function () {
                            $('#otp-verification-modal').modal('hide');
                            $('body').trigger('email:otpVerified', { 
                                email: $('#otp-email-hidden').val() 
                            });
                        }, 1000);
                    } else {
                        showAlert('error', data.message || 'Código incorrecto. Inténtalo de nuevo.');
                    }
                },
                error: function () {
                    $submitBtn.prop('disabled', false);
                    showAlert('error', 'Ocurrió un error de red. Intenta nuevamente.');
                }
            });
        });

        $('#btn-resend-otp').off('click').on('click', function (e) {
            e.preventDefault();

            var $btn = $(this);
            var url = $btn.data('url');
            var email = $('#otp-email-hidden').val();
            var csrfToken = $('input[name*="csrf_token"]').val();
            $(".otp-input").val('');

            showAlert('clear');

            $.ajax({
                url: url,
                type: 'POST',
                data: {
                    email: email,
                    csrf_token: csrfToken
                },
                success: function (data) {
                    if (data.success) {
                        showAlert('success', 'Se ha enviado un nuevo código a tu correo.');
                        startResendTimer(data.resendTime);
                    } else {
                        showAlert('error', data.message || 'Error al reenviar el código.');
                    }
                },
                error: function () {
                    showAlert('error', 'No se pudo conectar con el servidor.');
                }
            });
        });
    }
};